import candlePensVideoScreenshot from '../assets/candle-pens/candle-pens-video-screenshot.jpg'
import watchSectionBg from '../assets/candle-pens/watch-section-bg.jpg'

export const candlePensConfig = {
  couponCode: 'COLOZOO1',
  videoScreenshot: candlePensVideoScreenshot,
  watchSectionBg,
  // Drop a hero image into src/assets/candle-pens/ and assign the import here.
  heroImage: null as string | null,
  asin: 'B0H8Q11411',
  reviewUrls: {
    de: 'https://www.amazon.de/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0H8Q11411',
    fr: 'https://www.amazon.fr/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0H8Q11411',
    it: 'https://www.amazon.it/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0H8Q11411',
    es: 'https://www.amazon.es/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0H8Q11411',
    'en-GB': 'https://www.amazon.co.uk/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0H8Q11411',
    'en-US': 'https://www.amazon.com/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0H8Q11411',
  } as Record<string, string>,
  storeUrls: {
    de: 'https://www.amazon.de/stores/Colozoo/page/088F6D23-55D5-4281-ACB4-0E0BFBDD99A3',
    fr: 'https://www.amazon.fr/stores/Colozoo/page/315C207E-1141-4BBF-83D1-F857DA73F838',
    it: 'https://www.amazon.it/stores/Colozoo/page/6FBDACCD-D6A8-4017-971A-15D2488DE0D2',
    es: 'https://www.amazon.es/stores/Colozoo/page/938FD6BE-3585-4F1E-A08F-47E8AAEC8615',
    'en-GB': 'https://www.amazon.co.uk/stores/Colozoo/page/D00BCC46-3519-4856-B012-FD748CFEE7D6',
    'en-US': 'https://www.amazon.com/stores/Colozoo/page/C207523A-55EB-4191-B263-65E44BA822FD',
  } as Record<string, string>,
  youtube: {
    channel: 'https://www.youtube.com/@colozoo',
    videos: {
      'en-GB': 'https://youtu.be/JcXTcgzVcew',
      'en-US': 'https://youtu.be/JcXTcgzVcew',
      de: 'https://youtu.be/wVxHX4EBzVU',
      fr: 'https://youtu.be/nQe4AH7ZGA0',
      it: 'https://youtu.be/VeOfBmMR8JQ',
      es: 'https://youtu.be/xyQek0eWxNQ',
    } as Record<string, string>,
  },
}

export function normalizeCandlePensLang(language: string): string {
  if (language.startsWith('en-US')) return 'en-US'
  if (language.startsWith('en')) return 'en-GB'
  if (language.startsWith('de')) return 'de'
  if (language.startsWith('fr')) return 'fr'
  if (language.startsWith('it')) return 'it'
  if (language.startsWith('es')) return 'es'
  return 'en-GB'
}

export function getYoutubeUrl(language: string): string {
  const lang = normalizeCandlePensLang(language)
  return candlePensConfig.youtube.videos[lang] || candlePensConfig.youtube.channel
}

export function getAmazonReviewUrl(language: string): string {
  const lang = normalizeCandlePensLang(language)
  return candlePensConfig.reviewUrls[lang] || candlePensConfig.reviewUrls['en-GB']
}

export function getAmazonStoreUrl(language: string): string {
  const lang = normalizeCandlePensLang(language)
  return candlePensConfig.storeUrls[lang] || candlePensConfig.storeUrls['en-GB']
}

export const watchSectionBackgroundStyle = {
  backgroundImage:
    `linear-gradient(rgba(18, 85, 79, 0.15), rgba(18, 85, 79, 0.15)), url(${watchSectionBg})`,
}
